<div class="container " style="text-align: center;">
    <div class="row">
        <div class="col " style="margin-top: 45vh">
            <!-- <mat-icon aria-hidden="false" aria-label="Example home icon" class="bug">bug_report</mat-icon> -->
            <h1 for="error">This page is not found ! <span style="color: red;">404</span></h1>
        </div>
    </div>
</div>
